<template>
    <div>
        <div key="loading" class="flex col-span-12 justify-center" v-if="loading">
            <div class="aspect-[320/520] w-1/4 relative mb-sm sm:mb-md flex justify-center items-center">
                <i class="fa-regular fa-spinner-third h-[60px] w-auto animate-spin"></i>
            </div>
        </div>
        <div class="grid grid-cols-12 gap-y-lg sm:gap-x-md md:gap-y-xl" v-else>
            <div v-for="(item, index) in articles" :key="index" class="col-span-12 xs:col-span-6 sm:col-span-4">
                <blogitem :content="item" />
            </div>
        </div>
    </div>
</template>

<script>
import axios from 'axios';
import blogitem from './item';

export default {
    name: 'bloghighlight',
    props: ['posts', 'exclude'],

    data() {
        return {
            params: {
                per_page: 3,
                page: 1,
                include: [],
            },
            loading: false,
            articles: [],
        };
    },

    mounted() {
        if (this.posts.length > 0) {
            this.posts.forEach((post) => {
                this.params.include.push(post.id);
            });
        }

        this.params.exclude = this.exclude;
        this.getArticles();
    },

    methods: {
        getArticles() {
            this.loading = true;

            axios
                .get('/api/articles', { params: { ...this.params } })
                .then((response) => {
                    if (response.data.status === 200) {
                        this.articles = response.data.data;
                    } else {
                        this.articles = [];
                    }

                    if (this.posts.length > 0 && this.posts.length < 3) {
                        this.getExtraArticles();
                    }
                })
                .finally(() => (this.loading = false));
        },

        getExtraArticles() {
            this.loading = true;
            const limit = 3 - this.posts.length;

            this.params.per_page = limit;
            this.params.include = [];

            this.posts.forEach((post) => {
                this.params.exclude.push(post.id);
            });

            axios
                .get('/api/articles', { params: { ...this.params } })
                .then((response) => {
                    if (response.data.status === 200) {
                        this.articles = this.articles.concat(response.data.data);
                    }
                })
                .finally(() => (this.loading = false));
        },
    },

    components: {
        blogitem,
    },
};
</script>
